import styled from "styled-components"

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export { ContentWrapper }
